import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.625 14.25h8.125V6.125H6.625zm9.625.225a1.277 1.277 0 0 1-1.275 1.275H6.4a1.276 1.276 0 0 1-1.275-1.275V5.9c0-.338.134-.663.373-.902l.094-.084c.227-.186.512-.289.808-.289h8.575c.296 0 .581.103.808.29l.094.083.084.094c.186.227.289.512.289.808z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.875 5.375a.75.75 0 0 1-1.5 0V1.75H2.25v8.125h3.625a.75.75 0 0 1 0 1.5h-3.85A1.276 1.276 0 0 1 .75 10.1V1.525c0-.338.134-.663.373-.902l.094-.084c.227-.186.512-.289.808-.289H10.6c.296 0 .581.103.808.29l.094.083.084.094c.186.227.289.512.289.808z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "copy"}) } }